// extracted by mini-css-extract-plugin
export var alignBaseline = "_r-9";
export var alignCenter = "_r-5";
export var alignFlexEnd = "_r-7";
export var alignFlexStart = "_r-6";
export var alignSelfBaseline = "_r-e";
export var alignSelfCenter = "_r-a";
export var alignSelfFlexEnd = "_r-c";
export var alignSelfFlexStart = "_r-b";
export var alignSelfStretch = "_r-d";
export var alignStretch = "_r-8";
export var column = "_r-2";
export var columnReverse = "_r-4";
export var flex = "_r-0";
export var justifyCenter = "_r-f";
export var justifyFlexEnd = "_r-h";
export var justifyFlexStart = "_r-g";
export var justifySpaceAround = "_r-j";
export var justifySpaceBetween = "_r-i";
export var justifySpaceEvenly = "_r-k";
export var row = "_r-1";
export var rowReverse = "_r-3";
export var wrapNowrap = "_r-m";
export var wrapWrap = "_r-l";
export var wrapWrapReverse = "_r-n";